import { render } from "./UserRolesPermissionsPage.vue?vue&type=template&id=7beefaf5&scoped=true"
import script from "./UserRolesPermissionsPage.vue?vue&type=script&lang=js"
export * from "./UserRolesPermissionsPage.vue?vue&type=script&lang=js"

import "./UserRolesPermissionsPage.vue?vue&type=style&index=0&id=7beefaf5&scoped=true&lang=css"

import exportComponent from "D:\\Projects\\loop Company\\Apps\\cms-dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7beefaf5"]])

export default __exports__